export default "__VITE_ASSET__19d75688__"